<template>
  <el-dialog
    title="选择物流"
    :visible.sync="dialogVisible"
    width="350px"
    :before-close="handleCancel"
  >
    <el-form :model="form" :inline="true">
      <el-form-item label="出库通知单号">
        {{ form.code }}
      </el-form-item>
      <el-form-item label="选择物流">
        <BjSelectLogisticBusiness
          v-model="form.logisticBusinessId"
          :placeholder="$t('chooseText')"
          class="full-width"
          @change="onBusiness"
        />
      </el-form-item>
      <el-form-item label="快递单号">
        <BjInputCode
          v-model="form.trackingNumber"
          class="full-width"
          placeholder="请输入快递单号"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { stockApi } from '@/api';
const defaultForm = () => {
  return {
    logisticBusiness: null,
    logisticBusinessCode: null,
    logisticBusinessId: null,
    logisticCompany: null,
    logisticCompanyCode: null,
    logisticsId: null,
    orderNo: null,
    trackingNumber: null,
  };
};
export default {
  data() {
    return {
      dialogVisible: false,
      form: defaultForm(),
      rules: {},
    };
  },
  methods: {
    show(code, orderCode) {
      this.form = defaultForm();
      this.form.code = code; // 出库通知单号
      this.form.orderNo = orderCode; // 内部订单号
      this.dialogVisible = true;
    },
    onBusiness(val, data = {}) {
      this.form.logisticBusiness = data.name;
      this.form.logisticBusinessCode = data.code;
      this.form.logisticBusinessId = data.id;

      this.form.logisticCompany = data.companyName;
      this.form.logisticCompanyCode = data.companyCode;
      this.form.logisticsId = data.companyId;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleSend() {
      const { logisticBusinessId, trackingNumber } = this.form;
      if (!logisticBusinessId) {
        this.msgError('请选择物流');
        return;
      }
      if (!trackingNumber) {
        this.msgError('请输入快递单号');
        return;
      }
      stockApi
        .sendResultRecords({
          ...this.form,
        })
        .then(res => {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.handleCancel();
          this.reFresh();
        });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
